import { Col, Flex, Layout, Row, theme } from 'antd';
import type { ThemeConfig } from 'antd';
import React, { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCommunitySettings } from '@guuru/community-web';
import { Loading } from '@guuru/react-loading';
import { PartnerLogo } from '@guuru/react-partner-logo';
import { PoweredBy } from '@guuru/react-powered-by';
import { COLORS } from '@guuru/theme-common';
import ThemeProvider from '@guuru/theme-web';

const { Content, Footer } = Layout;

const { useToken } = theme;

const themeConfig: ThemeConfig = {
  components: {
    Card: {
      headerHeightSM: 20,
    },
    Rate: {
      marginXS: 4,
      controlHeightLG: 30,
    },
    Layout: {
      bodyBg: '#ffffff',
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      footerBg: '#ffffff',
      headerPadding: 0,
    },
  },
  token: {
    paddingLG: 12,
  },
};

const BasicLayout = function () {
  const { token } = useToken();
  const { partnerName, partnerId } = useCommunitySettings();

  if (!partnerName) {
    return <Navigate to="/" />;
  }

  return (
    <ThemeProvider
      theme={{ color: COLORS.primaryColor, antd: token }}
      configProvider={themeConfig}
    >
      <Layout>
        <Content>
          <Flex vertical gap={38}>
            <Col />
            <PartnerLogo id={partnerId} />
            <Row justify="center">
              <Col xs={22} xxl={20}>
                <Row justify="center">
                  <Suspense fallback={<Loading height={100} />}>
                    <Outlet />
                  </Suspense>
                </Row>
              </Col>
            </Row>
            <Col />
          </Flex>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          <PoweredBy
            url={`https://www.guuru.com/?utm_source=pages&utm_medium=pages&utm_campaign=pages&utm_term=${partnerId}&utm_content=${partnerId}`}
          />
        </Footer>
      </Layout>
    </ThemeProvider>
  );
};

export default BasicLayout;
